module.exports = __webpack_public_path__ + "static/img/096_TO8_1773_og.50a8c83.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/096_TO8_1773_og.jpg
// module id = g61Z
// module chunks = 0